import axios from 'axios'

import { LOGIN, CHARTLOGIN, CHARTS_URL, DASHBOARD_URL, VALIDATE_USER, USER_VISIT_COUNT, GET_MENU_RIGHT_BASED, USER_NAME, PASSWORD, BASIC_TOKEN_HEADER } from '../constants/api.config'

import { notify } from '../utils/notifyFunction' // Import your notify function

import { errorHandler } from '../utils/errorHandler'

const username = USER_NAME;
const password = PASSWORD;
const token = btoa(`${username}:${password}`); // base64 encoding
const isURL = (str) => /^https?:\/\//.test(str); // Check if the string is a URL


export async function rightBasedMenuFettcher(userID, moduleCode = "DSH", isUserObjectPassed, userObject) {
  try {
    if (isUserObjectPassed && !Object.keys(userObject).length) {
      return
    }

    const params = new URLSearchParams({
      LoginCode: userID,
      DivCode: "RNB",
      ParentCode: "",
      ModuleCode: moduleCode,
      prmLangCode: "en-US",
    });

    const config = {
      method: 'GET',
      url: `${DASHBOARD_URL}/${GET_MENU_RIGHT_BASED}?${params.toString()}`,
      headers: BASIC_TOKEN_HEADER
    };


    const result = await axios(config);

    // If there are Links, return them, otherwise return null
    if (result?.data?.Links?.length > 0) {

      const data = result.data.Links

      // Separate "FirstLevel" and "SecondLevel" items
      const firstLevelItems = data.filter(item => item.Level === "FirstLevel");
      const secondLevelItems = data.filter(item => item.Level === "SecondLevel");

      // Create a map for first level items with children
      const userRights = firstLevelItems.map(parent => {
        // Find all second level items with matching parentcode
        const children = secondLevelItems.filter(child => (child.parentcode.trim() === parent.code.trim()));
        return { ...parent, children };
      });

      let allowedRoutesArray = []
      let registeringRoutes = []

      if (userRights?.length > 0) {
        allowedRoutesArray = userRights.flatMap((right) =>
          right.children?.map((child) => {
            if (child.RouteJson && child.RouteJson.trim() !== '') {
              registeringRoutes = [...registeringRoutes, JSON.parse(child.RouteJson.replace(/'/g, '"').replace(/(\w+):/g, '"$1":').replace(/:\s*([a-zA-Z_][a-zA-Z0-9_]*)/g, ': "$1"'))]
            }

            return isURL(child.formobjname)
              ? child.formobjname
              : child.formobjname?.replace(/[\r\n]/g, '') || '/*';
          }) || []
        );
      }

      // {
      //   "Level": "FirstLevel",
      //     "code": "DSH_MAIN_DASHBOARD  ",
      //       "parentcode": "-                   ",
      //         "menuorder": 1,
      //           "menutitle": "Dashboard",
      //             "formtitle": "Dashboard",
      //               "formobjname": "",
      //                 "IsSSOURL": "No",
      //                   "RouteJson": "",
      //                     "children": [
      //                       {
      //                         "Level": "SecondLevel",
      //                         "code": "DSH_HOME            ",
      //                         "parentcode": "DSH_MAIN_DASHBOARD  ",
      //                         "menuorder": 1,
      //                         "menutitle": "Roads and Bridges (State)",
      //                         "formtitle": "Roads and Bridges (State)",
      //                         "formobjname": "/home\r\n",
      //                         "IsSSOURL": "No",
      //                         "RouteJson": "{\r\n    path: '/home',\r\n    name: 'HomeNew',\r\n    component: HomeNew,\r\n    exact: true,\r\n    shouldCardRender: true,\r\n    shouldChartRender: true\r\n  }"
      //                       },
      //                       {
      //                         "Level": "SecondLevel",
      //                         "code": "DSH_MMGSYRNB        ",
      //                         "parentcode": "DSH_MAIN_DASHBOARD  ",
      //                         "menuorder": 2,
      //                         "menutitle": "Roads and Bridges (Panchayat)",
      //                         "formtitle": "Roads and Bridges (Panchayat)",
      //                         "formobjname": "/dashboard/mmgsy",
      //                         "IsSSOURL": "No",
      //                         "RouteJson": "{\r\n    path: '/dashboard/mmgsy',\r\n    name: 'mmgsy',\r\n    component: HomeNew,\r\n    exact: true,\r\n    shouldCardRender: true,\r\n    shouldChartRender: true\r\n  }"
      //                       },
      //                       {
      //                         "Level": "SecondLevel",
      //                         "code": "DSH_BLDG            ",
      //                         "parentcode": "DSH_MAIN_DASHBOARD  ",
      //                         "menuorder": 3,
      //                         "menutitle": "Building (State)",
      //                         "formtitle": "Building (State)",
      //                         "formobjname": "/dashboard/buildings",
      //                         "IsSSOURL": "No",
      //                         "RouteJson": "{ path: '/dashboard/buildings', name: 'Buildings', component: HomeNew, exact: true, shouldCardRender: true, shouldChartRender: true }"
      //                       },
      //                       {
      //                         "Level": "SecondLevel",
      //                         "code": "DSH_HR              ",
      //                         "parentcode": "DSH_MAIN_DASHBOARD  ",
      //                         "menuorder": 9,
      //                         "menutitle": "HR- Employee Data",
      //                         "formtitle": "HR- Employee Data",
      //                         "formobjname": "/dashboard/hr\r\n",
      //                         "IsSSOURL": "No",
      //                         "RouteJson": "{\r\n    path: '/dashboard/hr',\r\n    name: 'HR',\r\n    component: HomeNew,\r\n    exact: true,\r\n    shouldCardRender: true,\r\n    shouldChartRender: true\r\n  }"
      //                       }
      //                     ]
      // }

      // const tempObj = {
      //   "Level": "FirstLevel",
      //   "code": "DSH_REPORTS  ",
      //   "parentcode": "-                   ",
      //   "menuorder": 9,
      //   "menutitle": "Report main menutitle",
      //   "formtitle": "Report main formtitle",
      //   "formobjname": "",
      //   "IsSSOURL": "No",
      //   "RouteJson": "",
      //   "children": [
      //     {
      //       "Level": "SecondLevel",
      //       "code": "DSH_REPORT_SCREEN            ",
      //       "parentcode": "DSH_REPORTS  ",
      //       "menuorder": 1,
      //       "menutitle": "report screen menutitle",
      //       "formtitle": "report screen formtitle",
      //       "formobjname": "/reportscreenmenu\r\n",
      //       "IsSSOURL": "No",
      //       "RouteJson": "{\r\n    path: '/reportscreenmenu',\r\n    name: 'ReportScreen',\r\n    component: ReportScreen,\r\n    exact: true,\r\n      }"
      //     },

      //   ]
      // }

      // const tempRegisteringRoute = {
      //   "path": "/reportscreenmenu",
      //   "name": "ReportScreen",
      //   "component": "ReportScreen",
      //   "exact": "true",
      //   // "shouldCardRender": "true",
      //   // "shouldChartRender": "true"
      // }
      console.log("see the userrights array :", userRights
      )
      const loggedinUserData = {
        UserRights: [...userRights],
        AllowedRoutes: [...allowedRoutesArray],
        RegisteringRoutes: [...registeringRoutes],
        ShowWelcomePage: userRights?.length && userRights[0]?.ShowWelcomePage === "NO" ? false : true
      };

      let tempUserObject

      if (isUserObjectPassed) {
        tempUserObject = { ...userObject }
      }
      else if (!isUserObjectPassed && !userObject) {
        tempUserObject = JSON.parse(localStorage.getItem("RNB_LOGGED_IN_USER_DATA")) || {};
      }


      tempUserObject = { ...tempUserObject, ...loggedinUserData }

      localStorage.setItem("RNB_LOGGED_IN_USER_DATA", JSON.stringify(tempUserObject));

      return tempUserObject;
    } else {
      // Only show server error messages if available
      const serverErrorMsg = result?.data?.ErrMsg?.[0]?.ErrMsg ||
        result?.data?.ErrMsg ||
        result?.data?.message;

      if (serverErrorMsg) {
        notify(serverErrorMsg, "error");
      }
      return null;
    }
  } catch (error) {
    console.error("Error fetching user rights:", error.message);

    // Only show server error messages
    const serverErrorMsg = error?.response?.data?.ErrMsg?.[0]?.ErrMsg ||
      error?.response?.data?.ErrMsg ||
      error?.response?.data?.message;

    if (serverErrorMsg) {
      notify(serverErrorMsg, "error");
    }

    throw error;  // Throw the error to be handled by the calling function
  }
}

export async function getUserVisitCount() {
  try {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    const formattedDate = `${dd}/${mm}/${yyyy}`;

    const params = new URLSearchParams({
      // FromDate: formattedDate,
      // ToDate: formattedDate,
      ModuleCode: "",
    });

    const config = {
      method: 'GET',
      url: `${DASHBOARD_URL}/${USER_VISIT_COUNT}?${params.toString()}`,
      headers: BASIC_TOKEN_HEADER
    };

    const result = await axios(config);
    return result?.data;
  } catch (error) {
    console.error("Error fetching user visit count:", error.message);
    return null;
  }
}

export default async function login(data) {
  try {
    // Generate a frontend session id for this browser session
    const frontendSessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    const params = new URLSearchParams({
      UserCode: data?.loginID?.trim(),
      Password: data?.password?.trim(),
      SessionID: frontendSessionId?.trim(),
    });

    const conf = {
      method: 'GET',
      url: `${DASHBOARD_URL}/${VALIDATE_USER}?${params.toString()}`,
      contentType: 'application/json',
      headers: BASIC_TOKEN_HEADER
    };


    const result = await axios(conf);

    // Check if the response has the expected structure
    if (!result?.data?.Links || !result.data.Links[0]) {
      // Check for server error message
      const serverErrorMsg = result?.data?.ErrMsg?.[0]?.ErrMsg ||
        result?.data?.ErrMsg ||
        result?.data?.message;

      if (serverErrorMsg) {
        notify(serverErrorMsg, "error");
      }
      return null;
    }

    const userDataObject = result.data.Links[0];

    const loggedinUserData = {
      RoleCode: userDataObject?.RoleCode,
      ErpUserID: userDataObject?.ErpUserID,
      YearID: userDataObject?.YearID,
      YearCode: userDataObject?.YearCode,
      Ref_DivisionID: userDataObject?.Ref_DivisionID,
      UserID: userDataObject?.UserID,
      UserName: userDataObject?.UserName,
      LoginUserID: userDataObject?.LoginUserID,
      EncLoginUserID: userDataObject?.encLoginUserID,
      UniqueUID: userDataObject?.UniqueUID,
      changed: 0
    }

    try {
      // Fetch user rights based on the user ID from the response
      const fetchedLoggedinUserData = await rightBasedMenuFettcher(userDataObject?.UserID?.trim(), "DSH", true, loggedinUserData);

      if (!fetchedLoggedinUserData) {
        // No custom message, only server messages will be shown from rightBasedMenuFettcher
        return null;
      }

      // Save the session id in sessionStorage (clears on browser close)
      sessionStorage.setItem('RNB_SESSION_ID', frontendSessionId);

      notify("Login successful!", "success");
      // Resolve with URL for redirection and user login data
      return { url: "home", loginData: fetchedLoggedinUserData };

    } catch (rightsError) {
      console.error("Rights fetching error:", rightsError);

      // Only show server error messages
      const serverErrorMsg = rightsError?.response?.data?.ErrMsg?.[0]?.ErrMsg ||
        rightsError?.response?.data?.ErrMsg ||
        rightsError?.response?.data?.message;

      if (serverErrorMsg) {
        notify(serverErrorMsg, "error");
      }
      return null;
    }

  } catch (error) {
    console.error("Login error:", error);

    // Only show server error messages
    const serverErrorMsg = error?.response?.data?.ErrMsg?.[0]?.ErrMsg ||
      error?.response?.data?.ErrMsg ||
      error?.response?.data?.message;

    if (serverErrorMsg) {
      notify(serverErrorMsg, "error");
    }

    return null;
  }
}